import React, { useContext } from 'react'
import AddIcon from '@material-ui/icons/Add'
import Button from '@material-ui/core/Button'
import DeleteIcon from '@material-ui/icons/Delete'
import TextField from '@material-ui/core/TextField'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import { sessionContext } from '@marketing-milk/frontend'
import { dynamicContext } from '../../context/DynamicContext'
import InputAdornment from '@material-ui/core/InputAdornment'
import { creativeContext } from '../../../../context/CreativeContext'

export function DynamicDescription() {
  const { user } = useContext(sessionContext)
  const { creative } = useContext(creativeContext)
  const canEdit = !creative!.locked
  const { descriptions, addDescription, delDescription, setDescription } =
    useContext(dynamicContext)
  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="w-100 d-flex">
            <Typography variant="h5" className="pt-2" data-testid="description-tab">
              Description
            </Typography>
            <Button
              className="ml-auto mr-0"
              color="secondary"
              variant="contained"
              disabled={descriptions.length === 5}
              onClick={addDescription}
            >
              <AddIcon className="mr-2" /> Add
            </Button>
          </div>
          <hr />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          {descriptions.map((description, i) => {
            const variation = i + 1
            const isDuplicate = descriptions.filter(x => x === description).length > 1
            return (
              <div className="mb-3" key={i}>
                <TextField
                  error={isDuplicate || !description}
                  helperText={
                    (isDuplicate || !description) && 'Field must be unique and cannot be empty'
                  }
                  id={`slide-description-${variation}`}
                  label={`Description ${variation}`}
                  fullWidth
                  value={description}
                  onChange={e => setDescription(i, e.target.value)}
                  disabled={!canEdit}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          data-testid={`delete-icon-${variation}`}
                          edge="end"
                          aria-label="delete"
                          onClick={() => delDescription(i)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            )
          })}
        </div>
      </div>
    </>
  )
}
